import script from "./GradeRangeFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./GradeRangeFilter.vue?vue&type=script&setup=true&lang=ts"

import "./GradeRangeFilter.vue?vue&type=style&index=0&id=cb9e312e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb9e312e"]])

export default __exports__